import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';
import DateRangeRightSidePanel from '@features/filter/v2/salesFunnel/DateRangeRightSidePanel';

import { storeSelectedFilterCheckboxType } from '@store/actions/FilterAction';

import { collectionDateRangePresets } from '@utils/Util';

const DATE_OPTIONS = [
	{ name: 'Style Creation Date', id: 'CREATION_DATE', constant: 'CREATION_DATE' },
	{ name: 'Sample Completed Date', id: 'SAMPLE_COMPLETED_DATE', constant: 'SAMPLE_COMPLETED_DATE' },
	{ name: 'Add to Favourite Date', id: 'ADD_TO_FAVOURITE_DATE', constant: 'ADD_TO_FAVOURITE_DATE' }
];

const Date = ({ filterPageName, type }) => {
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;
	const [activeLayer, setActiveLayer] = useState('');
	const dataFilterRef = useRef();
	const dispatch = useDispatch();
	const [dateFilterOptions, setDateFilterOptions] = useState([]);

	useEffect(() => {
		let dateFilterOptions = DATE_OPTIONS.map((item) => ({
			...item,
			hasInputField: true
		}));
		if (filterPageName === 'COLLECTION_DETAILS') {
			dateFilterOptions = dateFilterOptions.filter((item) => item.id !== 'ADD_TO_FAVOURITE_DATE');
		}
		setDateFilterOptions(dateFilterOptions);
	}, [activeLayer, filterPageName]);

	useClickOutside(dataFilterRef, () => {
		if (selectedField?.selectedCheckboxField === type) {
			dispatch(storeSelectedFilterCheckboxType(null));
		}
	});

	const getActiveLebelName = (option) => {
		setActiveLayer(option?.id);
	};

	return (
		<div ref={dataFilterRef}>
			<FilterName type={type} data={dateFilterOptions} />
			<Checkbox
				data={dateFilterOptions}
				type={type}
				nextFilterLevel={3}
				onSelectedOption={getActiveLebelName}
				showSearchBar={false}
				activeLayer={activeLayer}
			/>

			{selectedField?.selectedCheckboxField === type && [3].includes(currentSelectedFilterLevel) && (
				<div className="filter-submenu" style={{ zIndex: -1 }}>
					<DateRangeRightSidePanel
						type="DATE"
						key={activeLayer}
						filterPageName={filterPageName}
						className="date-content"
						presets={collectionDateRangePresets}
						activeLayer={activeLayer}
						isCloseOnOutsideClick={false}
					/>
				</div>
			)}
		</div>
	);
};

export default Date;
